import { IFormControl } from '../types';

export const delay = (time: number) => new Promise((resolve) => setTimeout(resolve, time));

export function calculateAge(birthDate: Date | string) {
    const today = new Date();
    const date = typeof birthDate === 'string' ? new Date(birthDate) : birthDate;
    let age = today.getFullYear() - date.getFullYear();
    const m = today.getMonth() - date.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
        age -= 1;
    }
    return age;
}

export function getValidationRule(control: IFormControl, code: string) {
    return (control.validations || []).find((validation) => validation.code === code);
}

export function getValidationMessage(control: IFormControl, code: string) {
    const rule = getValidationRule(control, code);
    return rule ? rule.message : code;
}

export function getVeryOffsetTop(node: HTMLElement) {
    let offsetTop = 0;
    while (node && node.offsetParent) {
        offsetTop += node.offsetTop;
        if (node.offsetParent instanceof HTMLElement) {
            // eslint-disable-next-line no-param-reassign
            node = node.offsetParent;
        } else {
            break;
        }
    }
    return offsetTop;
}

export function scrollWithJquery(offset: number) {
    if (typeof jQuery === 'undefined') {
        if (process.env.NODE_ENV !== 'production') {
            console.info("scrollWithJquery() failed. jQuery was undefined.");
        }
        return;
    }
    $('html,body').animate({ scrollTop: offset }, 639, 'swing');
}

export function getMenuHeight() {
    const menu = document.getElementById('navbar');
    return menu?.offsetHeight ?? 0;
}

export function scrollToRootOrError(e: any) {
    let { currentTarget } = e;
    if (currentTarget && currentTarget.tagName !== 'DIV') {
        while (currentTarget.id !== 'root') {
            currentTarget = currentTarget.parentNode;
        }
    }
    if (currentTarget) {
        // Need a delay for the possible errors to have a chance to appear
        setTimeout(() => {
            const possibleError = currentTarget.querySelector('div.field.has-error');
            const offset = possibleError ?
                getVeryOffsetTop(possibleError) - possibleError.offsetHeight - 100
                    :
                getVeryOffsetTop(currentTarget) - getMenuHeight();
            scrollWithJquery(offset);
        }, 15);
    }
}

export function scrollToTop() {
    scrollWithJquery(0);
}

export function getBooleanOrDefault(value: string) {
    if (value === 'false') {
        return false;
    }
    if (value === 'true') {
        return true;
    }

    return value;
}

export function hasTF21Theme(market: string | undefined, theme: string | undefined) {
    const m = market ? market : '';
    if(m.length && [''].indexOf(m) > -1) return true; // if you are 100% sure the entire market is TF21 themed, then add markets.{country} to the array.
    const t = theme ? theme : '';
    if(t === 'TF Bronze (TF21)') return true; // 100% match on one of the options in the Umbraco Data Type "Form Builder - visualTheme - Dropdown".
    if(t === 'Credento (2022)') return true; // Yes, actually. For rendering the same HTML structure.
    if(t === 'Halino (2022)') return true; // Yes, actually. For rendering the same HTML structure.
    return false;
}

export function stringToArray(str: string, separator: string = ",") {
    if(separator.length !== 1) return [];
    return str.split(separator).map((i) => { return i.trim() });
}

export function getFileExtension(str: string) {
    const ar = stringToArray(str, ".");
    return ar.length ? ar[ar.length - 1] : '';
}

export function getTrackingScriptNode(trackingScript: string) {
    const mightExist = document.querySelector('#trackingScript');
    mightExist?.remove();
    const node = document.createElement('script');
    node.id = 'trackingScript';
    node.innerHTML = trackingScript;
    return node;
}